<template>
  <div class="modal-out">
      <div class="modal">
          <div class="modal-header">
              <div class="title">选择收获地址</div>
              <button type="button" class="btn-close" @click="closeSelf">X</button>
          </div>
          <div class="modal-body" style="padding:20px">
            <el-table :data="goodsInfo" border stripe max-height="450">
                <el-table-column prop="receiveName" label="收货人" width="100"></el-table-column>
                <el-table-column prop="receivePhone" label="手机号" width="130"></el-table-column>
                <el-table-column prop="areaNamePath" label="地区" width="200"></el-table-column>
                <el-table-column prop="receiveAddress" min-width="200" label="详细地址"></el-table-column>
                <el-table-column label="操作" width="100" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleChoice(scope.$index, scope.row)">选择</el-button>
                        <el-button type="text" @click="handleAddressEdit(scope.$index, scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
          </div>
        <div class="modal-footer">
          <el-button type="primary" @click="showAddressAE">新增地址</el-button>
        </div>
      </div>

      <AddressAdd ref="myAddressAE" v-show="showModalAddressAE" v-on:closeAddressAE="closeAddressAE"
                  v-on:getAddress="getAddress" v-bind:areaValue="areaValue" ></AddressAdd>

  </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    import AddressAdd from "./WriteAddressAdd"

    export default {
        name: 'Address',
        data() {
            return {
                showModalAddressAE:false,
                loading: false,
                goodsInfo:[],
                elderly:'',
                totalItems:0,
                pageSize:20,
                pageIndex:1,
                elderlyCode:'',
                areaValue:[]
            }
        },
        components:{
          AddressAdd
        },
        methods: {
          init(elderlyCode){
              this.elderlyCode=elderlyCode
              this.getAddress()
              this.getArea();
          },
          closeSelf() {
              this.$emit("closeAddress");
          },

          getArea(){
            this.$axios({
              method: 'post',
              url: this.$shopUrl+"Area/ListAll",
              data: {
                timeStr: timeStr,
                sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                staffCode: getStaffCode(),
              }
            }).then((response) => {
              if (response.data.error == 0) {
                var data=JSON.stringify(response.data.data);
                data=JSON.parse(data.replace(/"listAreaDTO":\[\],/g,''))
                this.areaValue = data
              }else if(response.data.error == 1){
                this.$message.error(response.data.message)
              }
            })
          },



          handleAddressEdit(index, row){
            this.$refs.myAddressAE.init(row,this.elderlyCode);
            this.showModalAddressAE = !this.showModalAddressAE;
          },
          showAddressAE(){
            let row=''
            this.$refs.myAddressAE.init(row,this.elderlyCode);
            this.showModalAddressAE = !this.showModalAddressAE;
          },
          closeAddressAE:function(){
            this.showModalAddressAE = !this.showModalAddressAE;
          },


          handleChoice(index, row){
              this.closeSelf()
              this.$emit("setAddress",row);
          },

          getAddress(){
              this.$axios({
                  method: 'post',
                  url: this.$shopUrl+"UserAddress/ListForStaff",
                  data: {
                      sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                      timeStr:timeStr,
                      staffCode:getStaffCode(),
                      elderlyCode:this.elderlyCode
                  }
              }).then((response) => {
                      this.loading = false;
                      if (response.data.error == 0) {
                          this.goodsInfo=response.data.data;
                      }else if(response.data.error == 1){
                          this.$message.error(response.data.message)
                      }
                  })
          },


        }
    }


</script>

